import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Button } from 'storybook-ui'

import { selectAppName } from 'root-redux/selects/common'

import { useIsUsGeoRetentionFlow } from 'hooks/useIsUsGeoRetentionFlow'

import { SubscriptionContainer as Container } from 'common-styles'
import { APP_SECONDARY_BUTTON_THEMES, AppName } from 'root-constants'

type TProps = {
  onClick: () => void
}

export const TurnOffRenewalButton: React.FC<TProps> = ({ onClick }) => {
  const { t } = useTranslation()
  const appName = useSelector(selectAppName) as AppName
  const isUsGeoRetentionFlow = useIsUsGeoRetentionFlow()

  if (isUsGeoRetentionFlow) {
    return (
      <Button
        theme={APP_SECONDARY_BUTTON_THEMES[appName]}
        onClick={onClick}
        margin="16px auto"
      >
        {t('button.cancelSubscription')}
      </Button>
    )
  }

  return (
    <Container.ResetPassword onClick={onClick}>
      {t('subscription.turnOffRenewal')}
    </Container.ResetPassword>
  )
}
